import {useMutation} from 'react-query';
import putSaleAgents from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

const usePutSaleAgents = (handleAfterSuccess?: () => void) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPutSaleAgentsPayload) => {
      return putSaleAgents(payload);
    },
    onSuccess: data => {
      handleAfterSuccess && handleAfterSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePutSaleAgents;
